import { render, staticRenderFns } from "./Asider.vue?vue&type=template&id=162e7118&"
import script from "./Asider.vue?vue&type=script&lang=js&"
export * from "./Asider.vue?vue&type=script&lang=js&"
import style0 from "./Asider.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Asider.vue"
export default component.exports